import { Component, OnDestroy, OnInit } from '@angular/core';
import { ThemeService } from './core/services/theme.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { filter, takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { EventMessage, EventType } from '@azure/msal-browser';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  template: `
    <ng-progress ngProgressHttp />
    <router-outlet></router-outlet>
  `,
  providers: [ThemeService],
})
export class AppComponent implements OnInit, OnDestroy {
  errorMessage: string | null = null;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private themeService: ThemeService,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router
  ) {
    themeService.loadSavedTheme();
  }

  ngOnInit(): void {
    this.msalService.initialize().subscribe(() => {
      this.msalService.handleRedirectObservable().subscribe();
    });

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(
        (auth) => {
          this.errorMessage = auth.error[`errorMessage`];
          localStorage.clear();
          this.router.navigate(['/']);
          console.log('error', this.errorMessage);
        },
        (e) => {
          console.log('err', e);
        }
      );
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
